document.querySelectorAll('.joya-cc__accordion').forEach(function(wrapper) {
  var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function findVariant(card) {
    var variants = JSON.parse(card.querySelector('.joya-cc__variant-id').getAttribute('data-variants') || '[]');
    var selects = card.querySelectorAll('.joya-cc__variant-select');
    if (selects.length === 0) return variants[0];
    var chosen = Array.from(selects).map(function(s) { return s.value; });
    return variants.find(function(v) {
      return chosen.every(function(val, i) { return v['option' + (i + 1)] === val; });
    }) || null;
  }
  function updatePrice(card) {
    var v = findVariant(card);
    var input = card.querySelector('.joya-cc__variant-id');
    var priceEl = card.querySelector('.joya-cc__price');
    if (v) {
      input.value = v.id;
      var html = '';
      if (v.compare_at_price > v.price) html += '<span class="joya-cc__price--compare">' + formatMoney(v.compare_at_price) + '</span>';
      html += formatMoney(v.price);
      priceEl.innerHTML = html;
    } else {
      input.value = '';
      priceEl.textContent = '—';
    }
  }
  wrapper.querySelectorAll('.joya-cc__card').forEach(function(card) {
    card.querySelectorAll('.joya-cc__variant-select').forEach(function(s) {
      s.addEventListener('change', function() { updatePrice(card); });
    });
    var btn = card.querySelector('.joya-cc__add-btn');
    var errorEl = card.querySelector('.joya-cc__error');
    btn.addEventListener('click', function() {
      errorEl.textContent = '';
      var variantId = card.querySelector('.joya-cc__variant-id').value;
      if (!variantId) { errorEl.textContent = 'Selecione uma opção.'; return; }
      btn.disabled = true;
      btn.textContent = 'Adicionando...';
      var formData = new FormData();
      formData.append('id', parseInt(variantId));
      formData.append('quantity', 1);
      if (cartEl && cartEl.getSectionsToRender) {
        formData.append('sections', cartEl.getSectionsToRender().map(function(s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
      .then(function(result) {
        if (!result.ok) {
          errorEl.textContent = result.data.description || 'Produto indisponível.';
          btn.disabled = false; btn.textContent = 'Adicionar'; return;
        }
        btn.classList.add('joya-cc__add-btn--success');
        btn.textContent = '✓ Adicionado!';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'joya-combine-com',
            productVariantId: variantId,
            cartData: result.data
          });
        }
        if (cartEl) {
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          if (cartEl.renderContents) cartEl.renderContents(result.data);
        }
        setTimeout(function() {
          btn.disabled = false;
          btn.classList.remove('joya-cc__add-btn--success');
          btn.textContent = 'Adicionar';
        }, 2000);
      })
      .catch(function() {
        errorEl.textContent = 'Erro de conexão.';
        btn.disabled = false; btn.textContent = 'Adicionar';
      });
    });
  });
});
